import { trackSelfDescribingEvent } from '@snowplow/browser-tracker';

import type { Entity } from './entities';

/**
 * Fires on input focus (an input field becomes active and gets a cursor)
 */
export interface InputFocus {
  /**
   * name that identifies the field
   */
  fieldName: string;
  /**
   * the type of the field
   */
  fieldType:
    | 'checkbox'
    | 'date'
    | 'dropdown'
    | 'hidden'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'switch'
    | 'tel'
    | 'text'
    | 'textarea';
}

export const inputFocus = (data: InputFocus, context?: Entity[]) =>
  trackSelfDescribingEvent({
    event: { schema: 'iglu:com.starsgroup/input_focus/jsonschema/1-0-0', data },
    context
  });
